import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-button',
  templateUrl: './nav-button.component.html'
})
export class NavButtonComponent implements OnInit {
  @Input() targetRoute: string;
  @Input() buttonTitle: string;

  constructor() { }

  ngOnInit() {
  }

}
